import baseApi from 'api/baseApi';
import { TagType } from 'common/enums/api.enums';
import { IEmployeeRole } from 'common/interfaces/employee';
import { IPaginatedData } from 'common/interfaces/pagination';
import { IRoleFormData } from 'modules/permissions/interfaces/roles';

const roleApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getRolesList: builder.query<IPaginatedData<IEmployeeRole>, Record<string, unknown>>({
      query: params => ({
        url: `/api/v1/security/role`,
        method: 'GET',
        params,
      }),
      providesTags: [TagType.CorporationRoles],
    }),
    getRole: builder.query<IEmployeeRole, string>({
      query: uuid => ({
        url: `/api/v1/security/role/${uuid}`,
        method: 'GET',
      }),
      providesTags: [TagType.CorporationRoles],
    }),
    createRoleItem: builder.mutation<void, IRoleFormData>({
      query: data => ({
        url: '/api/v1/security/role',
        method: 'POST',
        data,
      }),
      invalidatesTags: (result, error) => {
        return !error ? [TagType.CorporationRoles] : [];
      },
    }),
    editRoleItem: builder.mutation<void, { role: IRoleFormData; id: string }>({
      query: ({ id, role }) => ({
        url: `/api/v1/security/role/${id}`,
        method: 'PUT',
        data: role,
      }),
      invalidatesTags: (result, error) => {
        return !error ? [TagType.CorporationRoles] : [];
      },
    }),
    changeRoleItemStatus: builder.mutation<void, { active: boolean; id: string }>({
      query: ({ id, active }) => ({
        url: `/api/v1/security/role/${id}/change-status`,
        method: 'PATCH',
        data: { active: active.toString() },
      }),
      invalidatesTags: (result, error) => {
        return !error ? [TagType.CorporationRoles] : [];
      },
    }),
  }),
});

export const {
  useGetRoleQuery: useGetRole,
  useGetRolesListQuery: useGetRolesList,
  useCreateRoleItemMutation: useCreateRoleItem,
  useEditRoleItemMutation: useEditRoleItem,
  useChangeRoleItemStatusMutation: useChangeRoleItemStatus,
} = roleApi;

export default roleApi;
